import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentVaComponent } from './payment-va.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgApexchartsModule } from 'ng-apexcharts';
import { SelectAcademicYearOnlyModule } from 'src/shared/modules/select-academic-year-only/select-academic-year-only.module';
import { SelectSchoolActivityModule } from 'src/shared/modules/select-school-activity/select-school-activity.module';
import { SelectSchoolLevelRelationV2Module } from 'src/shared/modules/select-school-level-relation-v2/select-school-level-relation-v2.module';
import { SelectSchoolLocationV2Module } from 'src/shared/modules/select-school-location-v2/select-school-location-v2.module';
import { SelectSchoolProgramCategoryModule } from 'src/shared/modules/select-school-program-category/select-school-program-category.module';
import { SelectSchoolProgramModule } from 'src/shared/modules/select-school-program/select-school-program.module';
import { StatusNoDataModule } from 'src/shared/modules/status-no-data/status-no-data.module';
import { PipeModule } from 'src/shared/pipes/pipe.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PaymentAccumulationSetupComponent } from './payment-accumulation-setup/payment-accumulation-setup.component';
import { RegistrationPaymentVaComponent } from './registration-payment-va/registration-payment-va.component';
import { RouterModule } from '@angular/router';
import { PaymentVaRoutingModule } from './payment-va-routing-module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FeatherModule } from "angular-feather";



@NgModule({
  declarations: [PaymentVaComponent, PaymentAccumulationSetupComponent, RegistrationPaymentVaComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatTableModule,
    NgSelectModule,
    SelectAcademicYearOnlyModule,
    SelectSchoolLevelRelationV2Module,
    SelectSchoolLocationV2Module,
    SelectSchoolProgramCategoryModule,
    MatCardModule,
    SelectSchoolProgramModule,
    SelectSchoolActivityModule,
    NgApexchartsModule,
    PipeModule,
    StatusNoDataModule,
    MatCheckboxModule,
    PaymentVaRoutingModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatPaginatorModule,
    MatTooltipModule,
    FeatherModule
],
  exports: [
    PaymentVaComponent
  ]
})
export class PaymentVaModule { }
